import React, { useState } from "react";
import { InputWrapper } from "../components/input";
import LoginTopImage from "../images/loginTopImage.png";
import { Form } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  return (
    <>
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: 448,
            height: 512,
            padding: "0 32px",
            backgroundColor: "#fff",
            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
          }}
        >
          <img
            src={LoginTopImage}
            alt="Logo"
            width={448}
            style={{ position: "relative", right: 32, marginBottom: 32 }}
          />
          <div
            style={{
              textAlign: "left",
              position: "relative",
              top: "-180px",
              left: "-20px",
            }}
          >
            <Link to="/">
              <ArrowLeftOutlined /> Back
            </Link>
          </div>

          <h4 style={{ fontWeight: 500, margin: "48px 0" }}>
            Don't worry. Resetting your password is easy, just tell us the email address
            you registered with Komb.
          </h4>
          <Form>
            <div>
              <h4
                style={{
                  textAlign: "left",
                  marginBottom: 12,
                  fontSize: 16,
                }}
              >
                Email
              </h4>
              <InputWrapper
                required
                placeholder="abc@xyz.com"
                value={email}
                onChange={handleChange}
              />
            </div>

            <button
              style={{ marginTop: 24, height: 40 }}
              // loading={loading}
              htmlType="submit"
              // onClick={handleForgetPassword}
            >
              Send Code
            </button>
          </Form>
          {/* <div style={{ textAlign: "right", marginTop: 24 }}>
            <StyledLink to="/resetpassword">Verify Code</StyledLink>
          </div> */}

          {/* {verify && <Link to="/resetpassword">Verify Code</Link>} */}
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
